var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"report__property-icon-container"},[_vm._t("icon")],2),_c('p',{staticClass:"report__property-icon-item-label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }